import { FunctionComponent, useContext } from "react";
import LineItemContext from "components/job/LineItem/LineItemContext";
import Title from "components/job/LineItem/KandaQuote/Title";
import Quantity from "components/job/LineItem/KandaQuote/Quantity";
import Total from "components/job/LineItem/KandaQuote/Total";
import Description from "components/job/LineItem/KandaQuote/Description";
import Price from "components/job/LineItem/KandaQuote/Price";
import Vat from "components/job/LineItem/KandaQuote/Vat";

export interface KandaQuoteProps {
  smaller?: boolean;
}

const KandaQuote: FunctionComponent<KandaQuoteProps> = ({
  smaller = false,
}) => {
  const { classNames } = useContext(LineItemContext);
  return (
    <div className={classNames.desktop?.container}>
      {!smaller && <Quantity />}
      <div className="flex flex-col w-full">
        <div className="flex flex-row w-full">
          <div className={classNames.desktop?.titleWrapper}>
            <div className="flex flex-row flex-1">
              {smaller && <Quantity />}
              <Title />
              {smaller && <Total />}
            </div>
            {smaller && <Description />}
          </div>
          <div>
            <div className={classNames.desktop?.values}>
              {!smaller && (
                <>
                  <Price />
                  <Vat />
                </>
              )}
              {!smaller && <Total />}
            </div>
          </div>
        </div>
        {!smaller && <Description />}
      </div>
    </div>
  );
};

export default KandaQuote;
